vue
<template>
    <div class="ordershipment-container">
        <div class="title_tip">
            快递发货最多支持10个包裹，当前为第1个包裹
        </div>
        <div class="form-con">
            <div class="back_col">
                <div class="form-item">
                    <label class="form-label">发货方式</label>
                    <div class="form-input">
                        <div class="radio-item" @click="delivery_type = 1">
                            <img class="radio_img"
                                :src="delivery_type === 1 ? '/src/assets/img/icons/need-logistics.png' : '/src/assets/img/icons/no-logistics.png'">
                            <span>需要物流</span>
                        </div>
                        <div class="radio-item" @click="delivery_type = 2">
                            <img class="radio_img"
                                :src="delivery_type === 1 ? '/src/assets/img/icons/no-logistics.png' : '/src/assets/img/icons/need-logistics.png'">
                            <span>无需物流</span>
                        </div>
                    </div>
                </div>
                <div class="form-item" v-if="delivery_type == 1">
                    <label class="form-label">快递公司</label>
                    <div class="form-input">
                        <div class="select_com" @click="showPicker = true">
                            <span v-if="!logistics_company">请选择快递公司</span>
                            <span class="select_text" v-else>{{ logistics_company }}</span>
                        </div>
                    </div>
                </div>
                <div class="form-item" v-if="delivery_type == 1">
                    <label class="form-label">快递单号</label>
                    <div class="form-input">
                        <input v-model="delivery_no" class="search-input" type="text" placeholder="请输入快递单号"
                            placeholder-style="color:#999" focus />
                        <img @click="openqrcode" src="@/assets/img/icons/qrcodeicon.png" class="qrcodeimg" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="order_list_cont">
            <div class="title-label">本次发货商品</div>
            <div class="order_list_class" v-for="(item, index) in orderDetail.products" :key="index">
                <div class="product-content">
                    <img :src="comapi.getImageUrl(item.cover_image)" class="product-img" alt="商品图片" />
                    <div class="product-info">
                        <div class="p_name_con">
                            <div class="p-title">{{ item.product_name }}({{ item.spec_name }})</div>
                            <span class="count">x{{ item.num }}</span>
                        </div>
                        <div class="p_specs_con">
                            <span>规格：{{ item.unit }}</span>
                        </div>
                        <div class="p-price-row">
                            ¥{{ item.pay_amount }}
                        </div>
                    </div>
                </div>
                <div class="delivered_ing">
                    <div class="lable_title">已发货数量</div>
                    <div class="lable_num">{{ item.delivered_num }}</div>
                </div>
                <div class="delivered_ing">
                    <div class="lable_title">剩余待发数量</div>
                    <div class="lable_num">{{ item.remaining_num }}</div>
                </div>
                <div class="delivered_ing">
                    <div class="lable_title">本次发货数量</div>
                    <div class="stepper">
                        <div class="step-btn minus" :class="{ disabled: item.current_delivery_num <= 0 }"
                            @click.stop="changeNum(item, -1)">-</div>
                        <div class="step-input">{{ item.current_delivery_num }}</div>
                        <div class="step-btn plus"
                            :class="{ disabled: item.current_delivery_num >= item.remaining_num }"
                            @click.stop="changeNum(item, 1)">+</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-action-bar">
            <button class="btn btn-default">取消</button>
            <button class="btn btn-primary" @click="confirmShipment">确认发货</button>
        </div>
        <van-popup v-model:show="showPicker" destroy-on-close position="bottom">
            <van-picker :columns="deliveryCompanies" :model-value="pickerValue" @confirm="onConfirm"
                @cancel="showPicker = false" />
        </van-popup>
    </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { showToast } from "vant";
import comapi from "@/utils/api/com";
import storeapi from "@/utils/api/store";
import authApi from "@/utils/api/auth";
import * as ww from '@wecom/jssdk'
const router = useRouter()
const route = useRoute()
const order_uuid = route.query.order_uuid
const delivery_type = ref(1)
const showPicker = ref(false)
const logistics_company = ref('')
const delivery_no = ref('')
const pickerValue = ref([])
const orderDetail = ref({})
const deliveryCompanies = ref([
    { value: '顺丰速运', text: '顺丰速运' },
    { value: '中国邮政EMS', text: '中国邮政EMS' },
    { value: '圆通速递', text: '圆通速递' },
    { value: '中通速递', text: '中通速递' },
    { value: '申通快递', text: '申通快递' },
    { value: '韵达速递', text: '韵达速递' },
    { value: '极兔速递', text: '极兔速递' },
    { value: '京东物流', text: '京东物流' },
    { value: '德邦快递', text: '德邦快递' },
    { value: '跨越速运', text: '跨越速运' },
])
async function initWeWorkConfig() {
    ww.register({
        corpId: import.meta.env.VITE_WECOM_CORPID,       // 必填
        agentId: import.meta.env.VITE_WECOM_AGENTID,                  // 必填，当前应用的 AgentID
        jsApiList: ['scanQRCode'], // 必填
        // 获取“企业签名”的回调
        getConfigSignature: async (url) => {
            // 这里的 url 是 SDK 自动传，不要手动用 window.location.href
            const res = await authApi.getsignature(url);
            return {
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
            };
        },

        // 获取“应用签名”的回调（跳转小程序必须有这个）
        getAgentConfigSignature: async (url) => {
            const res = await authApi.getAgentSignature(url);
            return {
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
            };
        },
    });
}
const onConfirm = ({ selectedValues, selectedOptions }) => {
    logistics_company.value = selectedOptions[0]?.text;
    pickerValue.value = selectedValues;
    showPicker.value = false;
};
onMounted(() => {
    if (!order_uuid) {
        showToast({
            message: '订单不存在',
        })
        router.back();
        return
    }
    getorderdetail();
    initWeWorkConfig();
})
// 打开二维码扫描
const openqrcode = () => {
    ww.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: function (res) {
            console.log('scanQRCode success', res)
            delivery_no.value = res.resultStr;
        },
        fail: function (res) {
            if (res.errMsg.indexOf('function_not_exist') > 0) {
                showToast({
                    message: '版本过低请升级',
                })
            }
            console.log('scanQRCode fail', res)
        }
    })
}
const getorderdetail = () => {
    storeapi.getuserorderdetail({
        order_uuid: order_uuid
    }).then(res => {
        if (res.code == 200) {
            let data = res.data;
            data.products.forEach(item => {
                item.current_delivery_num = 0;
            })
            orderDetail.value = data;
        }
    })
};
const confirmShipment = () => {
    if (delivery_type.value == 1) {
        if (!logistics_company.value) {
            showToast({
                message: '请选择物流公司',
            })
            return
        }
        if (!delivery_no.value) {
            showToast({
                message: '请输入物流单号',
            })
            return
        }
    }
    let products = orderDetail.value.products.filter(item => item.current_delivery_num > 0);
    if (products.length == 0) {
        showToast({
            message: '请选择要发货的商品',
        })
        return
    }

    let data = {
        order_uuid: order_uuid,
        delivery_type: delivery_type.value,
        logistics_company: logistics_company.value,
        delivery_no: delivery_no.value,
        delivery_product_skus: products,
    }
    storeapi.confirmShipment(data).then(res => {
        if (res.code == 200) {
            showToast({
                message: '发货成功',
            })
            router.back();
        }
    })
}
const changeNum = (item, step) => {
    const newVal = item.current_delivery_num + step;
    if (newVal < 0) return;
    if (newVal > item.remaining_num) return;
    item.current_delivery_num = newVal;
};
</script>

<style lang="less" scoped>
.ordershipment-container {
    height: 100vh;
    overflow: auto;

    .title_tip {
        padding: 10px 18px;
        background: rgba(220, 187, 137, 0.08);
        font-weight: 500;
        font-size: 13px;
        color: #9A753E;
    }

    .form-con {
        padding: 17px;

        .back_col {
            background: #fff;
            border-radius: 8px;
            padding: 10px;

            .form-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 17px 0;
                border-bottom: 1px solid #E5E5E5;

                &:last-child {
                    border-bottom: none;
                }

                .form-label {
                    width: 90px;
                    color: #333;
                    font-size: 15px;
                }

                .form-input {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: calc(100% - 90px);

                    .search-input {
                        flex: 1;
                        font-size: 15px;
                        color: #333;
                        border: none;
                        outline: none;
                        background: transparent;
                        width: auto;
                        height: 21px;
                    }

                    .qrcodeimg {
                        width: 23px;
                        height: 23px;
                    }

                    .radio-item {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 15px;
                        color: #666;

                        img {
                            width: 17px;
                            height: 17px;
                            margin-right: 5px;
                        }
                    }

                    .select_com {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 15px;
                        color: #666;

                        .select_text {
                            color: #333;
                        }
                    }
                }
            }
        }
    }

    .order_list_cont {
        padding: 0 17px;

        .title-label {
            font-size: 15px;
            color: #888;
            font-weight: bold;
            margin-bottom: 10px;
        }

        .order_list_class {
            padding: 13px 10px;
            margin-bottom: 10px;
            background: #fff;
            border-radius: 8px;

            .product-content {
                display: flex;

                &:not(:last-child) {
                    border-bottom: 1px solid #f5f5f5;
                    padding-bottom: 12px;
                    margin-bottom: 12px;
                }

                .product-img {
                    width: 80px;
                    height: 80px;
                    border-radius: 6px;
                    object-fit: cover;
                    margin-right: 12px;
                    background-color: #eeeeee;
                }

                .product-info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .p_name_con {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .p-title {
                            font-size: 15px;
                            color: #333333;
                            font-weight: 500;
                        }

                        .count {
                            color: #999999;
                            font-size: 14px;
                        }
                    }

                    .p_specs_con {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        color: #999999;
                        font-size: 12px;
                    }

                    .p-price-row {
                        display: flex;
                        justify-content: flex-end;
                        align-items: flex-end;
                        color: #FF7123;
                        font-size: 19px;
                    }
                }
            }

            .delivered_ing {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 13px;

                &:last-child {
                    margin-bottom: 0;
                }

                .lable_title {
                    font-size: 15px;
                    color: #666;
                }

                .lable_num {
                    font-size: 15px;
                    color: #333;
                }

                .stepper {
                    display: flex;
                    align-items: center;
                    border: 1px solid #EEEEEE;
                    border-radius: 4px;

                    .step-btn {
                        width: 25px;
                        height: 25px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 15px;
                        color: #666;
                        background-color: #FFF;

                        &.minus {
                            border-right: 1px solid #EEE;
                        }

                        &.plus {
                            border-left: 1px solid #EEE;
                        }

                        &.disabled {
                            color: #CCC;
                        }
                    }

                    .step-input {
                        width: 35px;
                        height: 25px;
                        line-height: 25px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 13px;
                        color: #333;
                    }
                }
            }
        }
    }

    .bottom-action-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #ffffff;
        padding: 10px 15px;
        display: flex;
        justify-content: flex-end;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
        z-index: 100;
        max-width: 450px;
        margin: 0 auto;

        .btn {
            height: 38px;
            padding: 0 20px;
            border-radius: 4px;
            font-size: 14px;
            margin-left: 10px;
            border: none;
            cursor: pointer;
        }

        .btn-default {
            background: #ffffff;
            border: 1px solid #dddddd;
            color: #666666;
        }

        .btn-primary {
            background: #cfaa71;
            /* 按钮金 */
            color: #ffffff;
        }
    }
}

// 适配底部栏在iPhone上的位置
@supports (padding-bottom: env(safe-area-inset-bottom)) {
    .bottom-action-bar {
        padding-bottom: calc(10px + env(safe-area-inset-bottom));
    }

    .ordershipment-container {
        padding-bottom: calc(80px + env(safe-area-inset-bottom));
    }
}
</style>